import type { ChangeFormField } from '../../types/changes';
import { storedYesNoValue, yesNoChoices } from './changeFormSchema';

export type ChecklistLayoutItem =
  | { kind: 'yes_no_row'; field: ChangeFormField; followers: ChangeFormField[] }
  | { kind: 'standalone'; field: ChangeFormField };

/** Algum Sim/Não tem campo condicionado (ex.: justificativa) — todas as linhas usam a mesma grade 3 colunas. */
export function checklistUsesThreeColumnGrid(allFields?: ChangeFormField[] | null): boolean {
  const fields = allFields ?? [];
  return fields.some(
    (item) =>
      item.field_type === 'yes_no' &&
      fields.some((child) => child.conditional_field_id === item.id),
  );
}

/** Sim/Não na esquerda, opções no meio, campos condicionados (ex.: justificativa) à direita. */
export function layoutChecklistFields(
  allFields?: ChangeFormField[] | null,
  visibleFields?: ChangeFormField[] | null,
): ChecklistLayoutItem[] {
  const catalog = allFields ?? visibleFields ?? [];
  const visible = visibleFields ?? catalog;
  const visibleIds = new Set(visible.map((item) => item.id));
  const sorted = [...visible].sort(
    (a, b) => (a.sort_order || 0) - (b.sort_order || 0) || a.id - b.id,
  );
  const consumed = new Set<number>();

  const followersOf = (parentId: number) =>
    catalog
      .filter((item) => item.conditional_field_id === parentId)
      .sort((a, b) => (a.sort_order || 0) - (b.sort_order || 0) || a.id - b.id);

  const items: ChecklistLayoutItem[] = [];
  for (const field of sorted) {
    if (consumed.has(field.id)) continue;
    if (field.conditional_field_id && visibleIds.has(field.conditional_field_id)) {
      continue;
    }
    if (field.field_type === 'yes_no') {
      const followers = followersOf(field.id);
      followers.forEach((item) => consumed.add(item.id));
      items.push({ kind: 'yes_no_row', field, followers });
      continue;
    }
    items.push({ kind: 'standalone', field });
  }
  return items;
}

export function formatYesNoDisplayLabel(field: ChangeFormField, raw: unknown): string {
  const text = String(raw ?? '').trim();
  if (!text) return '';
  const stored = storedYesNoValue(field, text);
  const choice = yesNoChoices(field).find((item) => item.value === stored);
  return choice?.label || text;
}
